"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get DocumentVirusScanStatus () {
        return DocumentVirusScanStatus;
    },
    get UpdateDocumentVirusScanStatusResponse () {
        return UpdateDocumentVirusScanStatusResponse;
    }
});
const _zod = require("zod");
const DocumentVirusScanStatus = _zod.z.enum([
    "clean",
    "no-tag",
    "unsafe"
]);
const UpdateDocumentVirusScanStatusResponse = _zod.z.object({
    virusScanStatus: DocumentVirusScanStatus
});
